import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "02865f3c-9afd-45ea-b6e9-5594623b9b4c",
    authority: "https://login.microsoftonline.com/organizations",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    // Schlaegt die stille Token-Erneuerung im versteckten Iframe fehl (typisch,
    // wenn der Browser Third-Party-Cookies blockt), wartet MSAL per Vorgabe
    // 6 Sekunden bis zum Abbruch. Erst danach greift der Redirect-Fallback in
    // utils/authFetch.ts. 4 Sekunden reichen fuer einen Roundtrip zu Entra und
    // begrenzen den schlechtesten Fall beim Oeffnen.
    iframeHashTimeout: 4000,
    loggerOptions: {
      // In Produktion nicht mitloggen: MSAL schreibt sonst bei jedem Start
      // dutzende Zeilen in die Konsole.
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || !import.meta.env.DEV) return;
        console.log(`[MSAL][${level}] ${message}`);
      },
    },
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["User.Read", "User.Read.All"],
};
